import React from "react";

const AboutUs = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">About me</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          Experience that becomes a dependable outcome
        </h2>

        <div className="row">
          <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
            <h2 className="text-8 fw-400 mb-3">
              Hi, I&apos;m <span className="fw-700 border-bottom border-3 border-primary me-2">Sina Khanjani</span>
            </h2>
            <p className="text-5">
              As a software developer and technical lead, I turn real business needs into software that is useful, maintainable, and ready to evolve.
              <br />
              My experience spans backend and web development, mobile applications, deployment, and production support. The focus is always on choosing the right solution for the project—not on listing every available tool.
              <br />
              In collaboration, I value clear communication, staged delivery, useful documentation, and ownership after handover.
            </p>
          </div>
          <div className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp" data-wow-delay="0.2s">
            <div className="featured-box style-4">
              <div className="featured-box-icon text-25 fw-500 bg-primary rounded-circle">
                <span className="wow heartBeat" data-wow-delay="1.3s">12</span>
              </div>
              <h3 className="text-7 wow rubberBand" data-wow-delay="2s">
                Years of <span className="fw-700">professional experience</span>
              </h3>
            </div>
          </div>
        </div>

        <div className="row gy-3 mt-4">
          <div className="col-6 col-lg-3 wow fadeInUp">
            <p className="text-muted fw-500 mb-0">Focus:</p>
            <p className="text-4 text-dark fw-600 mb-0">Web, mobile, and backend</p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.3s">
            <p className="text-muted fw-500 mb-0">Engagement:</p>
            <p className="text-4 text-dark fw-600 mb-0">Freelance and remote</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
